import { useEffect, useState } from 'react';
import { getMeta } from '../services/api';
import { lang } from '../i18n';

// "Data last updated" from GET /meta, formatted for the active language.
// getMeta() is cached in the api module, so multiple callers share one request.
// Returns a formatted date string, or null until loaded.
export function useDataLastModified() {
  const [iso, setIso] = useState(null);

  useEffect(() => {
    let active = true;
    getMeta()
      .then((m) => {
        if (active && m.dataLastModified) setIso(m.dataLastModified);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!iso) return null;
  return new Date(iso).toLocaleDateString(lang === 'ja' ? 'ja-JP' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
